import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { ReactComponent as PortfolioUnselected } from './img/unselected-icon.svg';
import { ReactComponent as PortfolioSelected } from './img/selected-icon.svg';
import { fractionalWithSpaces } from '../../helpers/formatFractional';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';

const ColorDataItem = ({text, value, isSelected}) => (
  <div className="portfolio-card-item ">
    <span className={`portfolio-card-item-title ${isSelected ? 'selected' : ''}`}>{text}</span>
    <span
      className={`portfolio-card-item-value ${value >= 0 ? 'green' : 'red'}`}
    >
      {value > 0 ? '+' : ''}
      {value}%
    </span>
  </div>
);

const PortfolioListItemComposite = ({ item, selectedKeys, setSelectedKeys, deprecated, is_locked }) => {
  const { t } = useTranslation('');
  const { name, total_value, portfolio_code } = item;
  const return_main = item.return;
  const volatility = item.vol;
  const cvar = item.cvar;

  const isSelecte = useMemo(() => {
    return selectedKeys?.includes(item?.id);
  }, [selectedKeys, item]);

  const setItemSelected = () => {
    if (selectedKeys?.includes(item?.id)) {
      setSelectedKeys(selectedKeys.filter(i => i !== item?.id));
    } else {
      setSelectedKeys([...selectedKeys, item?.id]);
    }
  };

  return (
      <div
        onClick={setItemSelected}
        className={`portfolio-card-composite ${!isSelecte ? 'unselected' : ''}`}>
        <p className='portfolio-card-icons'>
          {isSelecte ? <PortfolioSelected /> : <PortfolioUnselected/>}
        </p>
        <div className=''>
          <p className='portfolio-card-name'>{name}</p>
          <p className='portfolio-card-code'>
            {portfolio_code}
            {deprecated
              ? <span className='portfolio-card-deprecated'>{t('IN_EXECUTION')}</span>
              : is_locked
                ? <span className='portfolio-card-deprecated'>{t('LOCKED')}</span>
                : null}
          </p>
        </div>
        <p className='portfolio-card-value'>{`${fractionalWithSpaces(total_value)} kr`}</p>
        <Row justify={'center'} className='portfolio-card-text'>
          <Col className=''>
            <ColorDataItem
              isSelected={isSelecte} 
              text={t('RETURN')} 
              value={return_main}/>

          </Col>
          <Col className=''>
            <ColorDataItem
              isSelected={isSelecte} 
              text={t('VOLATILITY')} 
              value={volatility}/>

          </Col>
          <Col className=''>
            <ColorDataItem
              isSelected={isSelecte} 
              text={t('CVaR')} 
              value={cvar}/>

          </Col>
        </Row>
      </div>
  );
};

export default PortfolioListItemComposite;

PortfolioListItemComposite.propTypes = {
  item: PropTypes.object,
  selectedKeys: PropTypes.array,
  setSelectedKeys: PropTypes.func,
  deprecated: PropTypes.bool,
  is_locked: PropTypes.bool,
};

ColorDataItem.propTypes = {
  text: PropTypes.string,
  value: PropTypes.number,
  isSelected: PropTypes.bool,
};
